import React, { useEffect, useState } from "react";
import "./group.css";
import { Plus } from "lucide-react";
import MembersModal from "./MembersModal";
import { useLocation } from "react-router-dom";
import apiServiceHandler from "../../../service/apiService";
import HashLoader from "react-spinners/HashLoader";
import { getColorFromName } from "../../../utils/getColor";
import { useSelector } from "react-redux";

const GroupMembers = () => {
  const { pathname } = useLocation();
  const pathArr = pathname.split("/");
  const id = pathArr[pathArr.length - 1];

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const loadGroupData = useSelector((state) => state.groupData.loadGroupData);

  const [membersModal, setMembersModal] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0)
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const [members, setMembers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const toggleMembersModal = () => {
    setMembersModal(true);
    setSearchQuery('')
    setSelectedOption("add");
  };

  const toggleAllMembersModal = () => {
    setMembersModal(true);
    setSearchQuery('')
    setSelectedOption("members");
  };

  const closeModal = () => {
    setMembersModal(false)
    setAllUsers([])
    setItemOffset(0)
    setTotalUsers(0)
  }

  const getAllMembers = async () => {
    try {
      setLoading(true);
      const response = await apiServiceHandler(
        "GET",
        `api/groups/members/${id}`,
        {}
      );
      console.log(response?.data?.users?.slice(0, 2), 'members only')
      setMembers(response?.data?.users?.slice(0, 2));
      setLoading(false);
    } catch (error) {
      console.error("Error getting getAllUsers:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllMembers();
  }, []);

  useEffect(() => {
    if (loadGroupData) {
      getAllMembers();
    }
  }, [loadGroupData]);

  return (
    <div className="group-feed-view">
      <div className="group-card">
        <div className="card-wrapper">
          <div className="card-header">
            <h2 className="card-heading">Members</h2>
            {userDetails?.admin && (
              <button className="card-button" onClick={toggleMembersModal}>
                <Plus />
              </button>
            )}
          </div>
          {!loading ? (
            <div className="group-card-content">
              {members && members.length > 0 ? (
                members.map((member) => (
                  <div className="group-members">
                    <div
                      className="member-avatar"
                      style={{
                        backgroundColor: getColorFromName(member?.name),
                      }}
                    >
                      <div class="avatar-text">
                        {member && member.image ? (
                          <img
                            className="avatar__image"
                            src={member.image}
                            alt="User Avatar"
                          />
                        ) : (
                          <div className="user__avatar">
                            {member?.name.substr(0, 1)}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="member-content">
                      <div className="member-name">{member.name}</div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No Members Found</p>
              )}
            </div>
          ) : (
            <div className="member-loader">
              <HashLoader color="#d1b794" size={20} />
              <p>Loading Users</p>
            </div>
          )}
          <div className="card-action-footer">
            <a className="link" onClick={toggleAllMembersModal}>
              See all members
            </a>
          </div>
        </div>
      </div>
      <MembersModal
        isOpen={membersModal}
        onClose={closeModal}
        selectedOption={selectedOption}
        setSearchQuery={setSearchQuery}
        searchQuery={searchQuery}
        allUsers={allUsers}
        setAllUsers={setAllUsers}
        itemOffset={itemOffset}
        setItemOffset={setItemOffset}
        totalUsers={totalUsers}
        setTotalUsers={setTotalUsers}
      />
    </div>
  );
};

export default GroupMembers;
